import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Table, TableHead, TableBody, TableRow, TableCell, TableFooter, TableSortLabel, TableContainer } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import Paper from "@material-ui/core/Paper";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import classNames from "classnames";
import { connect } from 'react-redux';
import { setUser, getCustomerList, getSelectedCustomer, getQloadCustomerList } from '../../../store/actions';
import { isEmpty } from "lodash";
import TablePagination from '@material-ui/core/TablePagination';
import { whiteColor } from "assets/jss/material-kit-pro-react.js";
import history from '../../../../../src/history';
import {
    warningColor,
    primaryColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    defaultFont,
    blackColor,
    title,
    mrAuto,
    mlAuto,
    hexToRgb,
} from "assets/jss/material-kit-pro-react.js";

import authService from '../../../../components/api-authorization/AuthorizeService';


const useStyles = themse => ({
    title,
    mrAuto,
    mlAuto,
    warning: {
        color: warningColor[0],
    },
    primary: {
        color: primaryColor[0],
    },
    danger: {
        color: dangerColor[0],
    },
    success: {
        color: successColor[0],
    },
    info: {
        color: infoColor[0],
    },
    rose: {
        color: roseColor[0],
    },
    gray: {
        color: grayColor[0],
    },
    right: {
        textAlign: "right",
    },
    table: {
        marginBottom: "0",
        width: "100%",
        maxWidth: "100%",
        backgroundColor: "transparent",
        borderSpacing: "0",
        borderCollapse: "collapse",
        overflow: "auto",
        "& > tbody > tr, & > thead > tr": {
            height: "auto",
        },
    },
    tableShoppingHead: {
        fontSize: "0.75em !important",
        textTransform: "uppercase !important",
    },
    tableCell: {
        ...defaultFont,
        lineHeight: "1.5em",
        padding: "12px 8px!important",
        verticalAlign: "middle",
        fontSize: "0.875rem",
        borderBottom: "none",
        borderTop: "1px solid " + grayColor[6],
        position: "relative",
        color: grayColor[1],
    },
    tableHeadCell: {
        fontSize: "1.092rem",
        borderBottomWidth: "1px",
        fontWeight: "400",
        color: whiteColor,
        backgroundColor: grayColor[12],
        borderTopWidth: "0 !important",
    },
    tableCellTotal: {
        fontWeight: "500",
        fontSize: "1.0625rem",
        paddingTop: "20px",
        textAlign: "right",
    },
    tableCellAmount: {
        fontSize: "26px",
        fontWeight: "300",
        marginTop: "5px",
        textAlign: "right",
    },
    tableResponsive: {
        minHeight: "0.1%",
        overflowX: "auto",
    },
    tableStripedRow: {
        backgroundColor: grayColor[16],
    },
    tableRowHover: {
        "&:hover": {
            backgroundColor: grayColor[23],
        },
    },
    warningRow: {
        backgroundColor: warningColor[4],
        "&:hover": {
            backgroundColor: warningColor[5],
        },
    },
    dangerRow: {
        backgroundColor: dangerColor[4],
        "&:hover": {
            backgroundColor: dangerColor[5],
        },
    },
    successRow: {
        backgroundColor: successColor[4],
        "&:hover": {
            backgroundColor: successColor[5],
        },
    },
    infoRow: {
        backgroundColor: infoColor[4],
        "&:hover": {
            backgroundColor: infoColor[5],
        },
    },
    checked: {
        color: infoColor[0] + "!important",
    },
    checkedIcon: {
        width: "25px",
        height: "25px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", 0.54)",
        borderRadius: "3px",
    },
    uncheckedIcon: {
        width: "25px",
        height: "25px",
        padding: "9px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", .54)",
        borderRadius: "3px",
    },
    checkRoot: {
        padding: "14px",
        "&:hover": {
            backgroundColor:
                "rgba(" + hexToRgb(infoColor[0]) + ", 0.14) !important",
        },
    },
    content: {
        paddingBottom: "10px",
        paddingTop: "10px",
    },
});






class CustomerListData extends React.Component {

    state = {
        username: '',
        userSavedInStore: false,
        page: 0,
        rowsPerPage: 10
    }

    componentDidMount() {
        if (isEmpty(this.props.user)) {
            //dont have user
            console.log("dont have user")
            this.populateState();
       
        }
        else {
            //found user
            this.setState({ username: this.props.user.email, userSavedInStore: true }, () => {

                console.log("have user")
                this.props.getCustomerList();
                this.props.getQloadCustomerList();
            });
        }



    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])

        this.setState({ username: user && user.name, userSavedInStore: false }, () => {
            this.props.getCustomerList();
            this.props.getQloadCustomerList();
        });

    }




    handleChangePage = (event, newPage) => {

        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = event => {

        this.setState({ rowsPerPage: +event.target.value });
        this.setState({ page: 0 });
    };



    EditSelectedCustomer = (_user) => {
        if (_user !== null) {
            this.setState({ selectecCustomer: _user }, () => {
                this.props.getSelectedCustomer(_user);

                history.push('/editCustomer-page');
            });
        }

    }


    // UI 
    render() {

        const { classes } = this.props;

        //Table Builder 
        const headCells = [
            { id: "0", numeric: false, disablePadding: true, name: "Customer Name", sortItemCode: "customerName" },
            { id: "1", numeric: true, disablePadding: false, name: "Email", sortItemCode: "email" },
            { id: "2", numeric: true, disablePadding: false, name: "Telephone", sortItemCode: "telephone" },
            { id: "3", numeric: true, disablePadding: false, name: "Role", sortItemCode: "role" },
            { id: "4", numeric: true, disablePadding: false, name: "NMBS Reference", sortItemCode: "nmbsReference" },
            { id: "5", numeric: true, disablePadding: false, name: "Active", sortItemCode: "active" },
            { id: "6", numeric: true, disablePadding: false, name: "", sortItemCode: "" },
        ];

   

        const customHeadCellClasses =
            [
                classes.textRight,
                classes.textCenter,
                classes.textCenter,
            ]
        const customHeadClassesForCells = [0, 4, 5]


        const useSortableData = (items, config = null) => {
            const [sortConfig, setSortConfig] = React.useState(config);
            const [userList, setUserList] = React.useState(items); // populating product list and setProductList is used to update the (productList) state

            const sortedItems = React.useMemo(() => {
                let sortableItems = [...items];
                if (sortConfig !== null) {
                    sortableItems.sort((a, b) => {
                        if (a[sortConfig.key] < b[sortConfig.key]) {
                            return sortConfig.direction === 'ascending' ? -1 : 1;
                        }
                        if (a[sortConfig.key] > b[sortConfig.key]) {
                            return sortConfig.direction === 'ascending' ? 1 : -1;
                        }
                        return 0;
                    });
                }
                setUserList(sortableItems);
                return sortableItems;
            }, [items, sortConfig]);

            const requestSort = (key) => {
                let direction = 'ascending';
                if (
                    sortConfig &&
                    sortConfig.key === key &&
                    sortConfig.direction === 'ascending'
                ) {
                    direction = 'descending';
                }
                setSortConfig({ key, direction });
            };


            const requestChange = (key) => {

                let defaultTable = sortedItems.slice();
                let x = key.target;
                /*   console.log(x.value, rows);*/

                if (x.value === "")
                    setUserList(defaultTable);
                else {
                    const updatedList = defaultTable.filter(item => {
                        return (
                            item.searchString.toLowerCase().search(x.value.replace(/[^\w\s]/gi, "").toLowerCase()) !== -1
                            //CHANGE DO WILDCARD SERACH ON THIS
                        );
                    });

                    let filterList = [...updatedList];
                    setUserList(filterList);
                }
            };

            return { items: userList, requestSort, sortConfig, requestChange };
        };


        const CustomerListTable = (props) => {
            const { items, requestSort, requestChange, sortConfig } = useSortableData(props.rows);
            return (
                <div style={{ padding: "8px" }}>
                    <div>
                        <input
                            style={{
                                backgroundColor: "#",
                                fontSize: "18.5px",
                                padding: 12,
                                flexDirection: "row",
                                width: "100%",
                                border: '0.5px solid #125688'
                            }}
                            type="search"
                            placeholder="Search..."
                            name="search"
                            onChange={e => requestChange(e)} />
                        <br />
                        <br />
                    </div>


                    <Paper sx={{ width: '100%', overflow: 'hidden', }}>
                        <TableContainer style={{ maxHeight: 550, overflow: 'scroll' }}>
                            <div className={classes.tableResponsive}>
                                <Table stickyHeader aria-label="simple table" className={classes.table} >


                                    <TableHead className={classes.tableHeadCell}>
                                        <TableRow className={classes.tableRow}>
                                            {headCells.map((prop, key) => {
                                                const tableCellClasses =
                                                    classes.tableHeadCell +
                                                    " " +
                                                    classes.tableCell +
                                                    " " +
                                                    classNames({
                                                        [[customHeadCellClasses][
                                                            [customHeadClassesForCells].indexOf(key)
                                                        ]]: [customHeadClassesForCells].indexOf(key) !== -1
                                                    });
                                                return (
                                                    <TableCell style={{
                                                        top: "1",
                                                        zIndex: 1,
                                                        width: "calc(100% - 17px)",
                                                        height: "20px"
                                                    }} className={tableCellClasses} key={key}>
                                                        <TableSortLabel onClick={() => requestSort(prop.sortItemCode)}>
                                                            {prop.name}
                                                        </TableSortLabel>
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {items.map((prop, key) => {
                                            var rowColor = "";
                                            var rowColored = false;
                                            if (prop.color !== undefined) {
                                                rowColor = prop.color;
                                                rowColored = true;
                                                prop = prop.data;
                                            }
                                            const tableRowClasses = classNames({
                                                [classes.tableRowHover]: true,
                                                [classes[rowColor + "Row"]]: '#00bcd4',
                                                [classes.tableStripedRow]: true && key % 2 === 0,
                                            });
                                            return (
                                                <TableRow key={key} hover={true} className={classes.tableRow + " " + tableRowClasses} >
                                                    <TableCell className={classes.tableCell} >{prop.customerName}</TableCell>
                                                    <TableCell className={classes.tableCell} >{prop.email}</TableCell>
                                                    <TableCell className={classes.tableCell} >{prop.telephone}</TableCell>
                                                    <TableCell className={classes.tableCell} >{prop.role}</TableCell>
                                                    <TableCell className={classes.tableCell} >{prop.nmbsReference}</TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        <Checkbox
                                                            checked={prop.active}
                                                            tabIndex={-1}
                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                            classes={{
                                                                checked: classes.checked,
                                                                root: classes.checkRoot
                                                            }}

                                                            readOnly
                                                        />
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        <Button
                                                            color="instagram"
                                                            key={key}
                                                            style={{
                                                                borderRadius: 8,
                                                                /*                    backgroundColor: "#eab82c",*/
                                                                padding: "12px 12px",
                                                                fontSize: "12px"
                                                            }}
                                                            size="lg"
                                                            target="_blank"
                                                            onClick={e => this.EditSelectedCustomer(prop)}
                                                        >
                                                            <i class="far fa-edit"></i>
                                                            &nbsp; Edit
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[10]}
                                                count={this.props.cusList.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </div>
                        </TableContainer>
                    </Paper>

                </div>
            );
        };


        return (
            <div>
                <div className={classNames(classes.content, classes.mainRaised)}>
                    <GridContainer>
                        <GridItem md={12} sm={12}>
                            <h3 className={classes.title}>Manage Customer Accounts</h3>
                            <Button color="instagram"
                                onClick={() => history.push('/Register')}                            >
                                <i class="far fa-user"></i> &nbsp; Create New User
                            </Button>
                        </GridItem>
                        <GridItem md={12} sm={12}>
                            <div style={{ padding: "6px" }}>
                                <CustomerListTable rows={this.props.cusList} />


                            </div>
                        </GridItem>
                    </GridContainer>
                    <br />
                </div>

            </div>



        )
    }
}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        cusList: state.adminData.customerList,
        qloadCuslist: state.adminData.qloadCustomerList
        /*  sec: state.adminData.selectedCustomer*/
    };
};


export default
    connect(mapStateToProps, { setUser, getCustomerList, getSelectedCustomer, getQloadCustomerList })(withStyles(useStyles)(CustomerListData));   // used to export both the styling and redux